/* GSI product-card image slider — crossfade slides + dots + prev/next arrows + touch swipe.
   Markup: snippets/gsi-card-media-slider.liquid, inside .card__media[data-gsi-card-slider].
   Styling/stacking: assets/gsi-brand.css (.gsi-cardmedia*). No dependencies. */
(function () {
  var SWIPE_PX = 30;

  function setup(root) {
    if (root.__gsiSliderReady) return;
    root.__gsiSliderReady = true;

    var wrap = root.querySelector('[data-gsi-slides]');
    if (!wrap) return;
    var slides = [].slice.call(wrap.querySelectorAll('[data-gsi-slide]'));
    var n = slides.length;
    if (n < 2) return;
    var dots = [].slice.call(root.querySelectorAll('[data-gsi-dot]'));
    var i = 0;

    function show(k) {
      i = (k % n + n) % n;
      for (var s = 0; s < n; s++) slides[s].classList.toggle('is-active', s === i);
      for (var d = 0; d < dots.length; d++) {
        var on = d === i;
        dots[d].classList.toggle('is-active', on);
        if (on) dots[d].setAttribute('aria-current', 'true');
        else dots[d].removeAttribute('aria-current'); // a11y 4.1.2: keep aria-current in sync with the visible slide
      }
    }

    var prev = root.querySelector('[data-gsi-prev]');
    var next = root.querySelector('[data-gsi-next]');
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); show(i - 1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); show(i + 1); });
    dots.forEach(function (dot, di) {
      dot.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); show(di); });
    });

    /* Touch swipe. Touch events bubble up from the transparent overlay link, so we listen
       on the root and only cancel the click-through when the gesture is a real horizontal swipe. */
    var x0 = null, y0 = null, moved = false;
    root.addEventListener('touchstart', function (e) {
      var t = e.touches[0]; x0 = t.clientX; y0 = t.clientY; moved = false;
    }, { passive: true });
    root.addEventListener('touchmove', function (e) {
      if (x0 === null) return;
      var t = e.touches[0];
      if (Math.abs(t.clientX - x0) > 10 && Math.abs(t.clientX - x0) > Math.abs(t.clientY - y0)) moved = true;
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (moved && Math.abs(dx) > SWIPE_PX) { e.preventDefault(); show(dx < 0 ? i + 1 : i - 1); }
      x0 = null;
    }, { passive: false });
  }

  function init(ctx) {
    var list = (ctx || document).querySelectorAll('[data-gsi-card-slider]');
    for (var k = 0; k < list.length; k++) setup(list[k]);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  /* re-init cards injected by section reloads / quick-add / filtering */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
